// In-memory sample data for the /demo sandbox. Nothing here is persisted.
export const DEMO_JOB = { name: "Maple St Curb Cleanup", location: "1420 Maple St" };

// Reference ("before") + a suggested proof ("after") for each item, drawn from
// real job photos bundled in /public/shots so the demo looks alive instantly.
export const DEMO_ITEMS = [
  {
    id: "d1",
    title: "Wash concrete slurry off the paver apron",
    status: "done",
    ref: "/shots/concrete_before_1.webp",
    suggestedProof: "/shots/concrete_after_1.webp",
    proof: { url: "/shots/concrete_after_1.webp", caption: "Rinsed clean — no slurry left" },
    description: "",
  },
  {
    id: "d2",
    title: "Sweep & bag debris along the gutter line",
    status: "pending",
    ref: "/shots/concrete_before_2.webp",
    suggestedProof: "/shots/concrete_after_2.webp",
    proof: null,
    description: "",
  },
  {
    id: "d3",
    title: "Pressure-rinse the driveway entrance",
    status: "pending",
    ref: "/shots/concrete_before_3.webp",
    suggestedProof: "/shots/concrete_after_1.webp",
    proof: null,
    description: "",
  },
];

// Sample reference photo used when the owner adds a brand-new item in the demo.
export const DEMO_NEW_ITEM_SAMPLE = "/shots/concrete_before_2.webp";

// Turn a bundled public asset into a File the PhotoAnnotator can open.
export async function urlToFile(url, name = "sample.jpg") {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], name, { type: blob.type || "image/jpeg" });
}

export const freshItems = () => DEMO_ITEMS.map((it) => ({ ...it, proof: it.proof ? { ...it.proof } : null }));
